module.exports = __webpack_public_path__ + "img/none_car.91e34f45.png";